import { apiActions } from '../../_core/api';
import { Middleware } from 'redux';
import garbageRecordActions, {
    garbageRecordConstants,
    TGarbageRecordActions,
    EGarbageRecordActions,
} from './actions';
import { IStore } from '../../store';
import { commonUtils } from '../../_common';
import { jobActions } from '../../_core/job';
import { IAuthActions } from '../auth/actions';
import {
    IGarbageRecord,
} from './@types';
import { EMARPOLDocuments, EMARPOLModelName } from '../marpol/@types';

const garbageRecordMiddleware: Middleware<{}, IStore> =
    ({ dispatch, getState }) =>
    (next) =>
    (action: TGarbageRecordActions | IAuthActions) => {
        switch (action.type) {
            case EGarbageRecordActions.HISTORY_LOAD: {
				console.log("loading grb1");
				
                next(action);
                const job = jobActions(
                    garbageRecordConstants.FEATURE,
                    action.type
                );
                const { providedFilters: filters } = action.payload;
                dispatch(garbageRecordActions.document.filterSet(filters));

                dispatch(
                    apiActions.apiRequest<{ logs: { docs: IGarbageRecord[] } }>({
                        feature: action.type,
                        method: 'GET',
                        url: garbageRecordConstants.API,
						queryParams: {
							vesselId: filters.vesselId,
							marpolType: EMARPOLDocuments.GRB1,
							modelName: EMARPOLModelName.MARPOL,
							weekStart: filters.startDate,
							weekEnd: filters.endDate,
							state: {
								$eq: filters?.state ?? undefined
							},
							sortOrder: filters?.sortOrder ?? undefined,
						},
                        preExecute() {
                            dispatch(job.active({}));
                        },
                        postExecute: {
                            onSuccess({ data }) {
								const grb1Records = data.logs.docs.filter(
									(doc) => doc.marpolType === EMARPOLDocuments.GRB1
								);
                                dispatch(
                                    garbageRecordActions.document.historySet(
                                        commonUtils.arrayToObject(grb1Records)
                                    )
                                );
                                dispatch(job.success({}));
                            },
                            onError() {
                                dispatch(job.error({}));
                            },
                            finally() {
                                dispatch(job.idle({}));
                            },
                        },
                    })
                );
                break;
            }
            default:
                next(action);
        }
    };
export default garbageRecordMiddleware;
